import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Backdrop, Box, Button } from '@mui/material';
import AppLoader from '../../../components/AppLoader/AppLoader';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CheckPermissions from '../../../authorization/authorization';
import BasicTable from '../../../components/basicTable/basicTable';
import { cfpBaseUrl } from '../../../network/urls';
import { allCompaniesAPI, convertDatewithTime } from '../../../services/Functions';
import { tableStyle } from '../../../style/common';
import '../OrganizationManagement.scss';
import './CompanyManagement.scss';
import UserIconImage from '../../../images/user.jpg';

const displayValue = (value) => {
    if (value === null || value === undefined || value === '') return '-';
    return String(value);
};

const formatDetailDate = (dateValue) => {
    if (dateValue === null || dateValue === undefined || dateValue === '') return '-';
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime()) || date.getFullYear() < 1971) return '-';
    return convertDatewithTime(dateValue);
};

const DetailField = ({ label, value }) => {
    const text = displayValue(value);
    return (
        <div className="org-details-dialog__field">
            <span className="org-details-dialog__label">{label}</span>
            <p className={`org-details-dialog__value${text === '-' ? ' org-details-dialog__value--muted' : ''}`}>
                {text}
            </p>
        </div>
    );
};

const DetailSection = ({ title, children }) => (
    <section className="org-details-dialog__section">
        <div className="org-details-dialog__section-header">
            <span className="org-details-dialog__section-accent" />
            <h4>{title}</h4>
        </div>
        <div className="org-details-dialog__grid">{children}</div>
    </section>
);

export default function CompanyManagementTable(props) {
    //#region 
    const [companyTODataGrid, setCompanyTODataGrid] = useState([]);
    const [open, setOpen] = useState(false);
    const [open2, setopen2] = useState(false);
    const [dialogRowData, setDialogRowData] = React.useState({});
    const [dltCompany, setDltCompany] = useState()
    const [tableCompany, setTableCompany] = useState([]);
    const [viewBackdrop, setViewBackdrop] = useState(true);
    const [tableDataLoaded, setTableDataLoaded] = useState(false);
    const navigate = useNavigate();
    const { token, permissions } = useSelector((state) => state.auth);

    //#endregion
    useEffect(() => {
        if (!tableDataLoaded) return;
        apiToDataGridConversion();
        setViewBackdrop(false);
    }, [tableCompany, tableDataLoaded]);

    useEffect(() => {
        const callAllCompanies = async () => {
            setViewBackdrop(true);
            setTableDataLoaded(false);
            let companiesList = await allCompaniesAPI(token, cfpBaseUrl)
            if (companiesList) {
                setTableCompany(companiesList)
            } else {
                setTableCompany([])
            }
            setTableDataLoaded(true);
        }
        callAllCompanies()
    }, [])

    const filterCompany = (companyCode) => {
        let itemFound = tableCompany.find(item => item.companyCode === companyCode)
        return itemFound;
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleClose2 = () => {
        setopen2(false);
    };

    const onDelete = async () => {
        setViewBackdrop(true)
        var formdata = new FormData();
        formdata.append("companyCode", dltCompany);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "customerFaciliationPortal/deleteCompany", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    let myArray = [...tableCompany]
                    let index = myArray.findIndex(obj => obj.companyCode == dltCompany);
                    if (index != -1) {
                        myArray.splice(index, 1);
                        setTableCompany(myArray)
                    }
                }
                else {
                }

            })
            .catch(() => {});
        handleClose2();
        setViewBackdrop(false)
    }

    const tblColumns = [
        { field: "id", headerName: 'Code', headerAlign: 'left', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "completename", headerName: 'Complete Name', headerAlign: 'left', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        // { field: "bank_name", headerName: 'Bank Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        // { field: "erp_code", headerName: 'ERP Code', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        // { field: "capital_code", headerName: 'Cap. Cost Acc. No.', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        // { field: "security_code", headerName: 'Sec. Cost Acc. No.', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        // { field: "created_by", headerName: 'Creator', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle  },
        // { field: "created_at", headerName: 'Created', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle  },
        // { field: "updated_by", headerName: 'Updator', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle  },
        // { field: "updated_at", headerName: 'Updated', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle  },
        {
            headerName: "Action",
            sortable: false,
            field: 'buttons',
            headerAlign: 'center',
            align: 'center',
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            renderCell: (params) => {

                const onViewCompany = (e) => {
                    e.stopPropagation();
                    const item = filterCompany(params.id);
                    setDialogRowData(item);
                    setOpen(true);

                };

                const onDeleteCompany = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    setopen2(true);
                    setDltCompany(params.id)
                };

                const onEditCompany = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    const companyToEdit = filterCompany(params.id);
                    navigate('/company-management/update-company', { state: { companyToEdit } })
                };

                return (
                    <>
                        <Box>
                            {
                                CheckPermissions(permissions, 'Organization Management', 'Company Management', 'Read') ?
                                    <IconButton onClick={onViewCompany} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
                                        <VisibilityIcon sx={{ color: 'skyblue' }} fontSize='inherit' />
                                    </IconButton> : null
                            }
                            {
                                CheckPermissions(permissions, 'Organization Management', 'Company Management', 'Update') ?
                                    <IconButton onClick={onEditCompany} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
                                        <EditIcon fontSize="inherit" sx={{ color: 'blue' }} />
                                    </IconButton> : null
                            }
                            {
                                CheckPermissions(permissions, 'Organization Management', 'Company Management', 'Delete') ?
                                    <IconButton aria-label="delete" size="small" sx={{ margin: 0, padding: 0 }} onClick={onDeleteCompany}>
                                        <DeleteIcon fontSize="inherit" sx={{ color: 'red' }} />
                                    </IconButton> : null
                            }
                        </Box>
                    </>
                )
            }
        }
    ]

    const apiToDataGridConversion = () => {
        const myArray = tableCompany
        const tempArray = []
        if (myArray) {
            myArray.forEach((item) => {
                const dataGridObject = {
                    "id": item.companyCode,
                    "completename": item.companyName,
                    "roles": item.roleName,
                    "bank_name": item.compBankName ? item.compBankName : '-',
                    "erp_code": item.compErpCode ? item.compErpCode : '-',
                    "capital_code": item.compCapitalCostAccountNo ? item.compCapitalCostAccountNo : '-',
                    "security_code": item.compSecurityAccountNo ? item.compSecurityAccountNo : '-'
                }
                tempArray.push(dataGridObject)
            })
        }
        else {
            const dataGridObject = {
                "id": ' ',
                "connectionType": '',
                "applicantName": ' ',
                "applicantCNIC": ' ',
            }
            tempArray.push(dataGridObject)
        }
        setCompanyTODataGrid(tempArray);
    }

    return (
        <>
            <Box className='form-box org-management-list'>
                <h3 className='page-title'>Company Management</h3>
                <Box className='application-table' >
                    <BasicTable
                        data={companyTODataGrid}
                        columns={tblColumns}
                        sx={tableStyle}
                        rowHeight={37.5}
                        pageSize={18}
                        rowsPerPageOptions={[18, 30, 60]}
                        rowsPageOption={false}
                        getRowStyle={(params) => {
                            return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                        }} />
                </Box>
            </Box>

            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="md"
                className="alert-popups org-details-dialog"
                aria-labelledby="org-details-dialog-title"
            >
                <DialogTitle
                    id="org-details-dialog-title"
                    component="div"
                    className="dialog-title"
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                    <span className="org-details-dialog__title-text">Company Details</span>
                    <IconButton
                        onClick={handleClose}
                        size="small"
                        aria-label="Close company details"
                        className="org-details-dialog__close"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent className="dialog-content">
                    <div className="org-details-dialog__body">
                        <div className="org-details-dialog__hero">
                            <div className="org-details-dialog__logo-wrap">
                                <img
                                    className="org-details-dialog__logo"
                                    src={dialogRowData.companyLogo || UserIconImage}
                                    alt={dialogRowData.companyName || 'Company logo'}
                                    onError={(e) => {
                                        e.target.src = UserIconImage;
                                    }}
                                />
                            </div>
                            <div className="org-details-dialog__hero-meta">
                                <h2 className="org-details-dialog__name">
                                    {displayValue(dialogRowData.companyName)}
                                </h2>
                                <p className="org-details-dialog__code">
                                    Company ID: <strong>{displayValue(dialogRowData.companyCode)}</strong>
                                </p>
                                <span
                                    className={`org-details-dialog__status org-details-dialog__status--${
                                        dialogRowData.status === '0' ? 'active' : 'inactive'
                                    }`}
                                >
                                    {dialogRowData.status === '0' ? 'Active' : 'Inactive'}
                                </span>
                            </div>
                        </div>

                        <DetailSection title="Company Information">
                            <DetailField label="Latitude" value={dialogRowData.latitude} />
                            <DetailField label="Longitude" value={dialogRowData.longitude} />
                            <DetailField label="Created By" value={dialogRowData.createdBy} />
                            <DetailField label="Created At" value={formatDetailDate(dialogRowData.createdDate)} />
                            <DetailField label="Last Updated By" value={dialogRowData.updateBy} />
                            <DetailField
                                label="Last Updated At"
                                value={formatDetailDate(dialogRowData.updatedDate)}
                            />
                        </DetailSection>

                        <DetailSection title="Contact Person 1">
                            <DetailField label="Name" value={dialogRowData.cp1Name} />
                            <DetailField label="Phone" value={dialogRowData.cp1phone} />
                            <DetailField label="Mobile" value={dialogRowData.cp1Mobile} />
                            <DetailField label="Email" value={dialogRowData.cp1Email} />
                        </DetailSection>

                        <DetailSection title="Contact Person 2">
                            <DetailField label="Name" value={dialogRowData.cp2Name} />
                            <DetailField label="Phone" value={dialogRowData.cp2phone} />
                            <DetailField label="Mobile" value={dialogRowData.cp2Mobile} />
                            <DetailField label="Email" value={dialogRowData.cp2Email} />
                        </DetailSection>

                        <DetailSection title="Bank Details">
                            <DetailField label="Bank Name" value={dialogRowData.compBankName} />
                            <DetailField label="ERP Code" value={dialogRowData.compErpCode} />
                            <DetailField
                                label="Capital Cost Account No."
                                value={dialogRowData.compCapitalCostAccountNo}
                            />
                            <DetailField
                                label="Security Cost Account No."
                                value={dialogRowData.compSecurityAccountNo}
                            />
                        </DetailSection>
                    </div>
                </DialogContent>
            </Dialog>


            <Dialog
                open={open2}
                onClose={handleClose2}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {" Are you sure to delete this record"}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={handleClose2}>Cancel</Button>
                    <Button onClick={onDelete} autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <AppLoader />
            </Backdrop >
        </>
    )
}
